var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import bindAllTo from "./bind-all-to";
/**
 * Like lodash bindAll, but can take a function as the 2nd argument which is a filter.
 *
 * @param {any} target The object whose properties to bind
 * @param {any} args Things to bind: strings, or an array, or a function invoked for each method name
 * @return {any} The bound object
 */
export default function bindAll(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return bindAllTo.apply(void 0, __spreadArrays([target, target], args));
}
//# sourceMappingURL=bind-all.js.map